/**
 * creates the One Login url with the appropriate destination page query param
 *
 * @param {String} oneLoginUrl the One Login URL, e.g. 'https://one-dev.americanexpress.com/en-us/account/login'
 * @param {String} browserOrigin the domain of the destination path, e.g. 'https://accounts-dev.americanexpress.com'
 * @param {String} destinationPath the relative path of the destination page, e.g. '/en-us/banking/personal/savings/dashboard'
 */

export const generateOneLoginDestinationUrl = (
  oneLoginUrl,
  browserOrigin,
  destinationPath
) => {
  const encodedDestPage = encodeURIComponent(
    `${browserOrigin}${destinationPath}`
  );
  const oneLoginDestinationUrl = `${oneLoginUrl}?DestPage=${encodedDestPage}`;

  return oneLoginDestinationUrl;
};
